import { Component, Inject, OnInit, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Settings } from '@shared-interfaces/shared-settings';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'entitlement-settings',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    TranslateModule
  ],
  templateUrl: './entitlement-settings.component.html',
  styleUrl: './entitlement-settings.component.scss',
})
export class EntitlementSettingsComponent implements OnInit {
  dialog = inject(MatDialogRef);

  constructor(
    public dialogRef: MatDialogRef<EntitlementSettingsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: Settings = {
      serviceNickname: '',
      subscriptionId: '',
    },
  ) {}

  ngOnInit(): void {
    this.inputForm.patchValue({
      serviceNickname: this.data.serviceNickname,
    });
  }

  inputForm: FormGroup = new FormGroup({
    serviceNickname: new FormControl('', []),
  });

  clearNickName(): void {
    this.inputForm.value['serviceNickname'] = '';
  }

  save(): void {
    var settings = this.inputForm.value;
    settings['subscriptionId'] = this.data.subscriptionId;
    this.dialog.close(settings);
  }
}
